import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.select = this.el.querySelector('.js-contact-select');
        this.elements = this.el.querySelectorAll('[data-contact]');

        this.select.addEventListener('change', (e) => {
            this.elements.forEach((el) => {
                el.classList.toggle('is-active', el.getAttribute('data-contact') === e.target.value);
            });
        });

        this.elements.forEach((el) => {
            el.classList.toggle('is-active', el.getAttribute('data-contact') === this.select.value);
        });
    }
}
